<template>
<div style="max-with: 300px; min-with: 300px" class="d-flex justify-content-center">
  <div id="chartCategorias"></div>
</div>
</template>

<script>
import ApexCharts from 'apexcharts'
import { mapGetters } from 'vuex';
// eslint-disable-next-line
import { map, size, reduce, flatten } from 'lodash'
import moment from 'moment';
moment.locale('pt-br')
export default {
  name: 'graficoCategorias',
  props: ['colors'],
  data () {
    return {
      count: 0,
      element: null,
      options:{
        noData: {
          text: 'Carregando...'
        },
        series: [],
        chart: {
          type: 'donut',
          animations: {
            enabled: true,
            easing: 'easeinout',
            dynamicAnimation: {
              enabled: true,
              speed: 500
            }
          }
        },
        legend: {
          show: false
        },
        dataLabels:{
          enabled: false,
          style: {
            // colors: ['#F44336', '#E91E63']
          }
        },
        yaxis: {
          labels: {
            formatter: (value, opts) => {
              let val = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value) || 0
              return `${opts.config.legend[opts.seriesIndex]}: ${val}`
            }
          }
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            title: {
              formatter: () => {
                return ''
              }
            }
          }
        }
      }
    }
  },
  mounted () {
    this.options.colors = this.colors
    this.element = new ApexCharts(document.querySelector("#chartCategorias"), this.options)
    this.element.render()
    this.updateSeries()

  },
  watch: {
    'getCategoriasDashboard' (val) {
      this.updateSeries(val)
      this.count++
    }
  },
  computed: {
    ...mapGetters('relatorioCategorias', ['getCategoriasDashboard']),
    formatData () {
      let dados = []
      const result = this.getCategoriasDashboard
      if (size(result) === 0) {
        return dados
      }
      // eslint-disable-next-line
      const formatValores = flatten(map(result, v => {
        let valores = map(v.records, it => parseFloat(it.value).toFixed(2) * -1).reduce((a, b) => a + b )
        return valores
      }))
      // const total = reduce(formatValores, (a, b) => a + b)
      // const valores = map(formatValores, v => Math.round((v / total) * 100))
      const labels = map(result, v => v.name )

      return { valores: formatValores, labels }
    }
  },
  methods: {
    updateSeries (val) {
      console.log('val', val)
      if (size(val) === 0) {
         this.element.updateOptions({
           series: [],
           noData: {
             text: '..carregando!'
           }
         })
        return
      }
      this.element.updateOptions({
        series: this.formatData.valores,
        legend: this.formatData.labels
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#chart {
  text-align: center;
  min-width: 100%;
  max-width: 100%;
  margin: 0 auto;
}
</style>